import { render, staticRenderFns } from "./inform.vue?vue&type=template&id=4698b712&"
import script from "./inform.vue?vue&type=script&lang=js&"
export * from "./inform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports